import eventsWithThumbnails from './eventsWithThumbnails';
import getEventAssetIds from '../../../components/Notifications/helpers/getEventAssetIds';

/**
 * Set notifications asset thumbnails
 * @param {Object[]} items
 * @param {Object[]} thumbnails
 * @returns {Object} items
 */
// A page fetch only returns thumbs for that page. Skip cards with no overlap
// so an older page does not get url: null when the next batch lands.
const setThumbnails = (items, thumbnails) => items.map((item) => {
  if (!item.data || !eventsWithThumbnails.includes(item.type)) {
    return item;
  }
  const ids = getEventAssetIds(item, 4);
  if (!ids.length) {
    return item;
  }
  const hasMatch = ids.some((id) => thumbnails.some((entry) => entry._id === id));
  if (!hasMatch) {
    return item;
  }
  const previousById = new Map((item.thumbnails || []).map((thumb) => [thumb._id, thumb]));
  const matched = ids.map((id) => {
    const thumb = thumbnails.find((entry) => entry._id === id);
    const previous = previousById.get(id);
    return {
      _id: id,
      url: (thumb?.trashed || thumb?.restricted)
        ? null
        : (thumb ? (thumb.thumbnailLink || null) : (previous?.url || null)),
      isLoading: false,
      trashed: Boolean(thumb?.trashed ?? previous?.trashed),
    };
  });
  return {
    ...item,
    thumbnail: matched[0],
    thumbnails: matched,
  };
});

export default setThumbnails;
